import * as React from 'react';
import * as styles from '../styles.scss';
import { Fallback, SymbolSearch } from 'components/common';
import { IState } from 'redux/global-reducers';
import * as classNames from 'classnames';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { formatNumber, handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import { IOrderForm, IOrderFormConfig, OrderFormFieldKey } from '../config';
import CurrentPriceField from '../CurrentPriceField';
import { FormikErrors } from 'formik';
import { INewSymbolData } from 'interfaces/market';
import { Lang } from 'constants/enum';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { InfoBuyIn } from 'assets/svg';
import configDomain from 'config';

interface ISymbolSectionProps
  extends React.ClassAttributes<SymbolComponent>,
    WithNamespaces {
  readonly config: IOrderFormConfig;
  readonly isHorizontal: boolean;
  readonly marginRatio?: number;
  readonly marginPriceCap?: number;
  readonly currentSymbolDesc?: string | JSX.Element;
  readonly symbol?: INewSymbolData;
  readonly lang?: string;
  readonly isDerivatives?: boolean;
  readonly onClickPrice: (price?: number) => void;
  readonly onSymbolSearch: (symbolCode: string | null) => void;

  readonly buyInStockList: IState['buyInStockList'];

  readonly ErrorMessage: React.FC<{
    readonly message?: string;
  }>;
  readonly errors: FormikErrors<IOrderForm>;
}

class SymbolComponent extends React.Component<ISymbolSectionProps> {
  render() {
    const {
      t,
      config,
      isHorizontal,
      onClickPrice,
      marginPriceCap,
      marginRatio,
      ErrorMessage,
      errors,
      currentSymbolDesc,
      symbol,
      lang,
      onSymbolSearch,
      isDerivatives,
      buyInStockList,
    } = this.props;
    const buyInLabel =
      symbol &&
      !configDomain.hideWhenKrx && !configDomain.hideBuyinTemp &&
      buyInStockList.includes(symbol.s) ? (
        <>
          <div className={styles.BuyInLabel}>Buy-in</div>
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip id={'tooltip-BUY-IN'} className={styles.TooltipBox}>
                <div>{t('BuyInTip')}</div>
              </Tooltip>
            }
          >
            <InfoBuyIn />
          </OverlayTrigger>
        </>
      ) : null;
    return (
      <>
        {config[OrderFormFieldKey.SYMBOL] != null && (
          <div
            className={classNames(styles.SymbolSection, styles.FormField, {
              [styles.Vertical]: !isHorizontal,
            })}
            style={config[OrderFormFieldKey.SYMBOL]?.style}
          >
            <div className={styles.MainField}>
              <div className={styles.FieldInput}>
                <SymbolSearch
                  isForm={true}
                  placeholder={currentSymbolDesc}
                  onSymbolSearch={onSymbolSearch}
                  removeIndexStock={true}
                  verticalPosition={isHorizontal ? 'top' : 'bottom'}
                />
              </div>
            </div>
            {isHorizontal ? (
              <div className={styles.StockInfo}>
                <span>{symbol?.s}</span>
                {`(${symbol?.m})  ${
                  lang === Lang.VI ? symbol?.n1 : symbol?.n2
                }`}
                {/* BuyIn_Label */}
                {buyInLabel}
              </div>
            ) : (
              <div style={config[OrderFormFieldKey.CURRENT_PRICE]?.style}>
                <div className={styles.StockInfo}>
                  <span>{symbol?.s}</span>
                  {`(${symbol?.m}) ${
                    lang === Lang.VI ? symbol?.n1 : symbol?.n2
                  }`}
                  {/* BuyIn_Label */}
                  {buyInLabel}
                </div>
                <CurrentPriceField onClickPrice={onClickPrice} />
              </div>
            )}
            {!isDerivatives && (
              <div
                className={styles.MarginInfo}
                style={{
                  display: isHorizontal ? 'none' : 'flex',
                }}
              >
                <div
                  className={classNames(styles.FieldInfo, {
                    [styles.Ratio]: !isHorizontal,
                  })}
                  style={config[OrderFormFieldKey.MARGIN_RATIO]?.style}
                >
                  {`${t('Margin1')}: `}
                  <span style={{ color: 'white' }}>{marginRatio ?? '--'}%</span>
                </div>
                <div
                  className={classNames(styles.FieldInfo, {
                    [styles.Ratio]: !isHorizontal,
                  })}
                  style={
                    (config[OrderFormFieldKey.MARGIN_RATIO]?.style,
                    { textAlign: 'right' })
                  }
                >
                  {` ${t('Block Price')}: `}
                  <span style={{ color: 'white' }}>
                    {formatNumber(
                      marginPriceCap,
                      undefined,
                      undefined,
                      undefined,
                      '--'
                    )}{' '}
                    VNĐ
                  </span>
                </div>
              </div>
            )}
            <ErrorMessage message={errors.stockCode} />
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: IState) => ({
  buyInStockList: state.buyInStockList,
});

const mapDispatchToProps = {};

const SymbolSection = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(SymbolComponent)
  ),
  Fallback,
  handleError
);

export default SymbolSection;



// WEBPACK FOOTER //
// ./src/components/common/OrderForm/FormSection/Symbol.tsx